import PropTypes from 'prop-types';
import React from 'react';
import { SEARCH_TYPES } from '../../constants/constants';

class ViewHeader extends React.Component {
  constructor(props, context){
    super(props);
    this.router = context.router;
    this.state = {
      resultType: "search"
    };
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  componentDidMount(){
    this.loadData();
  }

  updateUrl = (type, e) => {
    e.preventDefault();
    const region = this.props.params.region && this.props.params.region.length > 0 ? '/' + this.props.params.region : '';
    const url = region + '/quicksearch/'+type+'/'+this.props.params.search;
    this.router.replace(url);
    this.setState({resultType: type}, this.props.updateResultType(type));
  }

  loadData = () => {
    const typeOfResults = this.props.params.searchtype;
    this.setState({resultType: typeOfResults});
  }

  render(){
    const results = this.props.results;
    return (
      <div>
        <ul className="menu">
          <li><a id="search-control" onClick={this.updateUrl.bind(this, SEARCH_TYPES.SEARCH)} href="#"
            className={this.state.resultType === SEARCH_TYPES.SEARCH ? 'active' : 'inactive'}>All Results ({results.saleTotalCount + results.rentalTotalCount})</a></li>
          <li><a id="sales-control" onClick={this.updateUrl.bind(this, SEARCH_TYPES.SALES)} href="#"
            className={this.state.resultType === SEARCH_TYPES.SALES ? 'active' : 'inactive'}>Sales Listings ({results.saleTotalCount})</a></li>
          <li><a id="rentals-control" onClick={this.updateUrl.bind(this, SEARCH_TYPES.RENTALS)} href="#"
            className={this.state.resultType === SEARCH_TYPES.RENTALS ? 'active' : 'inactive'}>Rental Listings ({results.rentalTotalCount})</a></li>
        </ul>
      </div>
    )
  }
}

ViewHeader.propTypes = {
  updateResultType: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  results: PropTypes.object.isRequired
}

export default ViewHeader;


// WEBPACK FOOTER //
// ./src/components/quicksearch/view-header.js